import { preview } from '@/components/form/preview'

import { Link } from '@mui/material'

import { useTexts } from '../hooks/useTexts'

export function Header() {
  const texts = useTexts()

  return (
    <preview.Header
      title={texts.headerTitle}
      subtitle={texts.subtitle}
      testId="communication-plan-view-header"
    >
      <Link
        href="https://workwave.my.site.com/routemanager/s/article/Enhanced-Communication-Plan-and-Usage"
        target="_blank"
        rel="noopener noreferrer"
        variant="caption"
        underline="none"
      >
        {texts.learnMoreLink}
      </Link>
    </preview.Header>
  )
}
